import ResultList from "./ResultList";

export default function QuestionResult(props) {
  const { question, questionNumber } = props;
  return (
    <>
      <ResultList answer={question} questionNumber={questionNumber} />
    </>
  );
}
